export default {
  PROCESS: "process",
  SELECTION: "selection",
  SETTINGS: "settings",
  VERIFY: "verify",
};
